'use es6';

import http from 'hub-http/clients/apiClient';
const BASE_FILE_UPLOAD_URL = 'content/filemapper/v1/upload';
/**
 * POST content/filemapper/v1/upload
 */

export function uploadFile(fullPath, file, updateProgress) {
  const formData = new FormData();
  formData.append('file', file);
  const encodedURL = encodeURIComponent(`${fullPath}/${file.name}`);
  return http.post(`${BASE_FILE_UPLOAD_URL}/${encodedURL}?buffer=false&failIfExists=true`, {
    timeout: null,
    data: formData,
    headers: {
      'content-type': false
    },
    withXhr: xhr => {
      xhr.upload.addEventListener('progress', updateProgress, false);
    }
  });
}